export default [
  {
    title: 2024,
    items: [
      "특허등록(출원번호:10-2024-0032269) 채터링 방지회로",
      "기술자료임치증(계약번호:2024-02-20-3382) 2KV 서지보호 LED 컨버터 및 DC제어 LED디밍 컨트롤 회로",
      "기술자료임치증(계약번호:2024-02-20-2259) AC 채터일 및 잔광제거 부하 보호 스위치회로",
      "매입등 DC타입(삼성 LED칩 18V) 플리커프리제품(2KV 서지보호) KC인증 취득",
      "RF센서 스위치(채터링 방지회로:특허등록) KC인증 취득",
    ],
  },
  {
    title: 2023,
    items: ["조광기 전용 IC직접회로 회전형 매입등 플리커프리 제품 KC인증 취득"],
  },
  {
    title: 2022,
    items: ["조광기 스위치 DC제어 KC인증 (국내 최초) 취득"],
  },
  {
    title: 2021,
    items: ["PIR 매입 센서등 KC인증 취득"],
  },
  {
    title: 2020,
    items: [
      "KC 고효율기자재 매입등 인증 취득",
      "고정형 30W 직부등, 센서등 KC인증 취득",
      "특허등록(출원번호:30-2019-0046576) 천장용 조명등",
    ],
  },
  {
    title: 2019,
    items: ["RF 매입등 15W, RF 고정형 20W. 30W KC인증 취득"],
  },
  {
    title: 2018,
    items: ["매입등 2종 기기 KC인증 취득"],
  },
  {
    title: 2017,
    items: ["회사설립"],
  },
];
